export const CURRENT_CONFIG = {

  // license
  appId: '151729',
  appKey: '771f3b22f18be6dbea9b1d52eca513f',
  appLicense: 'g1MW5/ly4QbzAsvsPubwxHvZ1I+pIStsV6xmyUaeVnL6CwL8to4EuIeoEIF3lyc1ALYOn5Fj05TaTLmB3Brv6ashEaH52SEvkglYS0eWdwRnkLCjS1kBh/k+48Yh3HrbLqC5NjrEpj+xe2mjmSKtkqV5vRCvpuA/aeKNPP1PuoE=',

  // http
  baseURL: 'https://cloud.vision-bos.de',
  websocketURL: 'wss://cloud.vision-bos.de/api/v1/ws',

  // livestreaming
  rtmpURL: 'rtmp://88.99.25.205/live/',
  gbServerIp: '',
  gbServerPort: '',
  gbServerId: '',
  gbAgentId: '',
  gbPassword: '',
  gbAgentPort: '',
  gbAgentChannel: '',
  rtspUserName: '',
  rtspPassword: '',
  rtspPort: '8554',
  agoraAPPID: '',
  agoraToken: '',
  agoraChannel: '',

  // map
  amapKey: '',

}
